// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3MY2H","list":"BalanceDue_list__23IpK","listRow":"BalanceDue_listRow__1cjnZ","total":"BalanceDue_total__17W5L"};